import React from "react";
import effect1 from "../../card/effect1.json";
import effect2 from "../../card/effect2.json";
import effect4 from "../../card/effect4.json";
import effect5 from "../../card/effect5.json";
import effect6 from "../../card/effect6.json";
import effect7 from "../../card/effect7.json";
import effect8 from "../../card/effect8.json";
import { Helmet } from "react-helmet-async";
import Nofoundpage from "../../pages/Nofoundpage";
import { Tictac } from "./Tictac";
import "./reference.css";

export function Pendulum(props) {
  let pruevaIN = [];
  const posTittle = { marginTop: "1%" };
  switch (props.props.ID) {
    case "robotica-empresa-economia":
      pruevaIN = effect1;
      break;
    case "ciencia":
      pruevaIN = effect2;
      break;
    case "tecnologia":
      pruevaIN = effect4;
      break;
    case "mito":
      pruevaIN = effect5;
      break;
    case "nuevo-dispositivos":
      pruevaIN = effect6;
      break;
    case "espacio":
      pruevaIN = effect7;
      break;
    case "inteligencia-artificial":
      pruevaIN = effect8;
      break;
    default:
      console.error("Archivo no dir");
      return <Nofoundpage />;
  }

  
  function lookImgHtml( look )  {
    if ( look[0] === "NaN"){
      return "https://coronadosdelbien.com/HD48.ico"
    }else{
      return "https://coronadosdelbien.com/"+look
    }
  }
  function lookMetaHtml(stringArray , int, other) {
    let element;
    let arrayLi =["CIENCIA","ROBÓTICA EMPRESA ECONOMÍA","TECNOLOGÍA","INTELIGENCIA ARTIFICIAL","NUEVOS DISPOSITIVOS","ESPACIO","MITO" ] ;
    let arraySlug = ["ciencia","robotica-empresa-economia","tecnologia","inteligencia-artificial","nuevos-dispositivos","espacio","mito"];
    switch (int) {
      case 1:
        for (let index = 0; index < arrayLi.length; index++) {
          if (arrayLi[index] === stringArray) {
            if( ((index+int) === arrayLi.length-1 )  ) {
              if (other === 2) {
                element = arraySlug[index+int];
              } else {
                element = arrayLi[index+int];
              }
            }else if ( ((index+int) > arrayLi.length-1 )) {
              if (other === 2) {
                element = arraySlug[index-(int*2)];
              } else {
              element = arrayLi[index-(int*2)];
              }
            }
            else{
              if (other === 2) {
                element = arraySlug[index+int];
              } else {
                 element = arrayLi[index+int];
              }
            }
            break; 
          }
        }
        return element
      case 2:
        for (let index = 0; index < arrayLi.length; index++) {
          if (arrayLi[index] === stringArray) {
            if( ((index+int) === arrayLi.length-1 )  ) {
              if (other === 2) {
                  element = arraySlug[index+int];
              } else {
                  element = arrayLi[index+int];
              }
              
            }else if ( ((index+int) > arrayLi.length-1 )) {
              if (other === 2) {
                element = arraySlug[index-(int*2)];
              } else {
                element = arrayLi[index-(int*2)];
              }
            }
            else{
              if (other === 2) {
              element = arraySlug[index+int];
                
              } else {
              element = arrayLi[index+int];
                
              }
            }
            break; 
          }
        }
        return element
      default:
        break;
    }
  }


  const SeoObjet = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: `${pruevaIN[0].name}`,
    description: `${ pruevaIN[0].title +" "+ pruevaIN[0].lasttitle}`,
    keywords: `${pruevaIN[0].keywords}`,
    image:[ `${lookImgHtml(pruevaIN[0].img.slice(0,1))}` ],
    datePublished: new Date("2023-06-15T09:25:01.340Z").toISOString(),
    author: [{
      "@type" : "Person",
      name : "C.M.I",
      jobTitle: "programmer",
      url : "https://x.com/@GlassDroom"
    }],
    publisher:[
      {
        "@type":"Organization",
        name: "Droommk12",
        url: "Droommk12@Gmail.com"
      }
    ],
    url: `https://www.coronadosdelbien.com/${pruevaIN[0].slug}`,
  };
  const SeoObjectRutaNav = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement:[{
      "@type": "ListItem",
      "position":1,
      name: `${pruevaIN[0].name}`,
      item: `https://www.coronadosdelbien.com/${pruevaIN[0].slug}`,
      },
      {"@type": "ListItem",
        "position":2,
        name:`${lookMetaHtml(pruevaIN[0].name,1,1)}`,
        item: `https://www.coronadosdelbien/${lookMetaHtml(pruevaIN[0].name,1,2)}`
      },
      {"@type": "ListItem",
        "position":3,
        name:`${lookMetaHtml(pruevaIN[0].name,2,1)}`,
        item: `https://www.coronadosdelbien/${lookMetaHtml(pruevaIN[0].name,2,2)}`
      }
    ],
  }

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(SeoObjet)}</script>
        <script type="Application/ld+json">{JSON.stringify(SeoObjectRutaNav)}</script>
      </Helmet>
      <div lang="es">
        <section>
          {pruevaIN.map((e, index) => {
            return (
              <div key={index}  style={{ userSelect: 'none', WebkitUserSelect: 'none' }}>
                <hgroup>
                <div /* data-nosnippet = no permite mostar el contenido ( H1 en la meta description ) */
                 >
                <h1 style={posTittle}>{e.name}</h1>
              </div>
              </hgroup>
                {" "}
                <Tictac props={e} />
              </div>
            );
          })}
        </section>
      </div>
    </>
  );
}